import cx from 'classnames'
import { type ReactNode } from 'react'

import { type SanityFrameBuilderPortableText } from '../../data/sanity/queries/types/content'

import ChevronIcon from '../utility/chevron-icon'
import PortableText from '../utility/portable-text'

interface ConfigurationDefinitionProps {
  stepNumber: number
  title: string
  footerContent?: SanityFrameBuilderPortableText
  onClose: () => void
  children: ReactNode
  className?: string
}

const ConfigurationDefinition = ({
  stepNumber,
  title,
  footerContent,
  onClose,
  children,
  className,
}: ConfigurationDefinitionProps) => {
  return (
    <div className={cx('flex flex-col sm:h-full', className)}>
      <div
        onClick={onClose}
        className="grow-0 shrink-0 flex flex-row-reverse justify-end items-center h-[78px] py-5 px-6 select-none hover:cursor-pointer border-b hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center space-x-4">
          <ChevronIcon
            direction="left"
            className="flex-none inline-block h-[12px]"
          />

          <div className="flex flex-col justify-center h-full space-y-1 text-sm">
            {stepNumber}. {title}
          </div>
        </div>
      </div>

      <div className="py-6 space-y-6 sm:overflow-y-auto">{children}</div>

      {!!footerContent && (
        <div className="grow-0 shrink-0">
          <PortableText content={footerContent} className="py-5 border-t" />
        </div>
      )}
    </div>
  )
}

export default ConfigurationDefinition
